var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.questions),function(q){return _c('CounselingQuestion',{key:q.id,attrs:{"question":q,"value":_vm.getQuestionAnswer(q.id)},on:{"input":function($event){return _vm.setQuestionAnswer(q.id, $event)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }